import React from 'react';
import {
	useStripe,
	useElements,
	PaymentElement,
} from '@stripe/react-stripe-js';
import { fetchPaymentPayload, SaveTransaction } from '../../redux/api';
import { completeStage, selectStage } from '../../redux/slices/stageSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import { display, selectSession } from '../../redux/slices/sessionSlice';
import useState from 'react-usestateref';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const StripeForm = () => {
	const { t } = useTranslation();
	const [validationErrorEU, setValidationErrorEU] = useState<boolean>(false);
	const [errorField, setErrorField] = useState('');

	const [____, setLoading, loading] = useState(false);
	const { token, reservation, propertyInfo } = useAppSelector(selectSession);
	const stripe = useStripe();
	const elements = useElements();
	const dispatch = useAppDispatch();
	const { stages, stage } = useAppSelector(selectStage);
	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		if (!stripe || !elements) return;

		const result = await stripe.confirmPayment({
			elements,
			confirmParams: {
				return_url: window.location.href,
			},
			redirect: 'if_required',
		});
		console.log('*********confirmStripePaymentResult:', result);
		if (result.error) {
			toast.error(t('StripeConfirmPaymentError'), { autoClose: 10000 });
			//alert(`Payment failed: ${result.error.message}`);
		} else {
			//alert(`Payment Success`);

			await processPaymentResponse({
				type: 'ON_SUCCESS',
				value: {
					status: 'Succeeded',
					transactionId: result.paymentIntent?.id, // make sure this ID exists
					result: result,
				},
			});
		}
	};

	const processPaymentResponse = async (data: any) => {
		console.log(
			'*********processPaymentResponse:',
			reservation?.PmsConfirmationNo
		);

		if (data?.type === 'ON_SUCCESS' && data.value?.status === 'Succeeded') {
			const response = await SaveTransaction(token, {
				pmsConfirmationNo: reservation?.PmsConfirmationNo,
				reservationID: reservation?.ReservationID,
				ReferenceNo: data?.value?.transactionId,
				JsonResponse: JSON.stringify(data.value?.result),
			});
			console.log('*********Transaction response:', response);

			if (response?.status === 200 && response?.data?.result) {
				console.log('Dispatching completeStage...');
				dispatch(
					completeStage({
						token,
						stageID: stage?.stepID,
						ReservationID: reservation?.ReservationID,
						type: 'checkin',
						confirmationNo: reservation?.PmsConfirmationNo,
						stages,
						propertyCode: propertyInfo?.propertyCode ?? '',
					})
				)
					.unwrap()
					.then(() => {
						setLoading(false);
					});

				dispatch(display(true));
			} else {
				console.log(
					'*********Transaction response Error:',
					response.data.result
				);
				toast.error(t('SaveTransaction'), { autoClose: 10000 });
			}
		}
	};

	return (
		<div style={{ textAlign: 'center', margin: '20px 0' }}>
			<form onSubmit={handleSubmit}>
				<button
					style={{
						background: '#1f315a',
						border: 'none',
						color: 'white',
						padding: '12px 28px',
						fontSize: '1.1rem',
						fontWeight: '600',
						borderRadius: '50px',
						transition: 'all 0.3s ease',
						cursor: 'pointer',
					}}
					onMouseOver={(e) =>
						((e.target as HTMLButtonElement).style.opacity = '0.9')
					}
					onMouseOut={(e) =>
						((e.target as HTMLButtonElement).style.opacity = '1')
					}>
					Pay Now
				</button>{' '}
				<ToastContainer />
			</form>
		</div>
	);
};

export default StripeForm;
